import { css } from '@emotion/core'
import { measures } from 'styles/variables'

const { unit } = measures

export const menu = css`
  text-align: center;
`

export const item = css`
  display: inline-block;

  width: ${16 * unit}px;
`

// Style to completely disable the hover effect with higher specificity
export const noHoverWrapper = css`
  /* Target any figure within this wrapper */
  & figure {
    overflow: hidden;
  }
  
  /* Target the ::before pseudo-element with high specificity */
  & figure::before {
    display: none !important;
    content: none !important;
    opacity: 0 !important;
  }
  
  /* Override the hover state with high specificity */
  & figure:hover::before {
    display: none !important;
    content: none !important;
    opacity: 0 !important;
    top: 100% !important;
    transition: none !important;
  }
`
